import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: "button[nz-button]:not([nzSize])",
    host    : {
        "[class.ant-btn-lg]": "buttonLarge"
    }
})
export class NzButtonSizeDirective{
    buttonLarge : boolean = true;
}